import { useEffect, useState } from 'react'
import { X } from 'phosphor-react'
import styles from './Notification.module.css'
import { SOUNDS } from '../../constants/sounds'
import { useSound } from '../../hooks/useSound'

export type NotificationType = {
  id: string
  icon: string
  title: string
  message: string
  time?: string
}

type Props = {
  notification: NotificationType
  onClose: (id: string) => void
}

export default function Notification({ notification, onClose }: Props) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLeaving, setIsLeaving] = useState(false)
  
  const playNotification = useSound(SOUNDS.NOTIFICATION, { volume: 0.5 })

  useEffect(() => {
    playNotification()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10)

    const timer = setTimeout(() => {
      handleClose()
    }, 5000)

    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    setIsLeaving(true)
    setTimeout(() => {
      onClose(notification.id)
    }, 300)
  }

  return (
    <div 
      className={`${styles.notification} ${isVisible ? styles.visible : ''} ${isLeaving ? styles.leaving : ''}`}
      onClick={handleClose}
    >
      <div className={styles.content}>
        <div className={styles.headerSection}>
          <div className={styles.header}>
            <div className={styles.titleRow}>
              <img src={notification.icon} alt={notification.title} className={styles.icon} />
              <span className={styles.title}>{notification.title}</span>
            </div>
            <div className={styles.rightSection}>
              <span className={styles.time}>{notification.time || 'now'}</span>
              <button className={styles.closeBtn} onClick={handleClose} aria-label="Fechar">
                <X size={14} weight="bold" />
              </button>
            </div>
          </div>
        </div>
        <div className={styles.messageSection}>
          <p className={styles.message}>{notification.message}</p>
        </div>
      </div>
    </div>
  )
}